<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/clean-step1')"></span>
    </div>
    <div class="title">请描述房间数目</div>
    <div class="main">
			<div class="item-title">
				<img src="../../assets/img/clean/room/livingroom.svg"> 客厅
      </div>
      <div class="item">
				<div class="option-btn" :class="{ active:  order.data.livingroom=='0'}" @click="orderUpdate('livingroom','0')">0</div>
				<div class="option-btn" :class="{ active:  order.data.livingroom=='1'}" @click="orderUpdate('livingroom','1')">1</div>
				<div class="option-btn" :class="{ active:  order.data.livingroom=='2'}" @click="orderUpdate('livingroom','2')">2</div>
				<div class="option-btn more" :class="{ active:  order.data.livingroom=='more'}" @click="orderUpdate('livingroom','more')">更多</div>
      </div>

			<div class="item-title">
				<img src="../../assets/img/clean/room/bedroom.svg"> 卧室 / 书房 / 杂物间
      </div>
      <div class="item">
				<div class="option-btn" :class="{ active: order.data.bedroom=='0'}" @click="orderUpdate('bedroom','0')">0</div>
				<div class="option-btn" :class="{ active: order.data.bedroom=='1'}" @click="orderUpdate('bedroom','1')">1</div>
				<div class="option-btn" :class="{ active: order.data.bedroom=='2'}" @click="orderUpdate('bedroom','2')">2</div>
				<div class="option-btn" :class="{ active: order.data.bedroom=='3'}" @click="orderUpdate('bedroom','3')">3</div>
				<div class="option-btn" :class="{ active: order.data.bedroom=='4'}" @click="orderUpdate('bedroom','4')">4</div>
      </div>

			<div class="item-title">
				<img src="../../assets/img/clean/room/bathroom.svg"><span class="color-orange">+ </span><img src="../../assets/img/clean/room/toilet.svg"> 浴室（带厕所）
      </div>
      <div class="item">
				<div class="option-btn" :class="{ active:  order.data.bathroom=='0'}" @click="orderUpdate('bathroom','0')" v-if="order.data.livingroom=='0' && order.data.bedroom=='1'">0</div>
				<div class="option-btn" :class="{ active:  order.data.bathroom=='1'}" @click="orderUpdate('bathroom','1')">1</div>
				<div class="option-btn" :class="{ active:  order.data.bathroom=='2'}" @click="orderUpdate('bathroom','2')">2</div>
				<div class="option-btn more" :class="{ active:  order.data.bathroom=='more'}" @click="orderUpdate('bathroom','more')">更多</div>
      </div>

			<div class="item-title">
				<img src="../../assets/img/clean/room/toilet.svg"> 仅厕所
      </div>
      <div class="item">
				<div class="option-btn" :class="{ active: order.data.toiletroom=='0'}" @click="orderUpdate('toiletroom','0')">0</div>
				<div class="option-btn" :class="{ active:  order.data.toiletroom=='1'}" @click="orderUpdate('toiletroom','1')">1</div>
				<div class="option-btn" :class="{ active:  order.data.toiletroom=='2'}" @click="orderUpdate('toiletroom','2')">2</div>
				<div class="option-btn more" :class="{ active:  order.data.toiletroom=='more'}" @click="orderUpdate('toiletroom','more')">更多</div>
      </div>

    </div>

    <transition name="fade">
      <v-modal  v-if="showModal" @close="showModal = false">
        <div slot="body">
			
					<div class="modal-title">地毯是否需要清洁</div>
					<div class="multilayer">
						<div class="option-btn" @click="needCarpet()" v-bind:class="{ active: order.data.is_carpet == 1 }">需要</div>
						<div class="option-btn" @click="orderUpdate('is_carpet','0');" v-bind:class="{ active: order.data.is_carpet == 0 }">不需要</div>
					</div>

					<div class="info-box">
						<div>
              <div v-show="order.data.is_carpet==0||order.data.is_carpet==3">
                <div class="info">到家提供专业地毯清洁服务</div>
              </div>
              <div v-show="order.data.is_carpet == 1">
                <div class="info">地毯清洁服务 $70 起</div>
              </div>
              <!-- <div v-show="order.data.is_carpet == 1">
                <v-counter @plus="plus" @minus="minus" :num='order.data.carpet' type='carpet'>
                  <span slot="label">清洁房间数</span>
                </v-counter>
                <div class="carpetInfo"> （ 卧室、客厅及其他含地毯的房间都算在内 ）</div>
              </div> -->
						</div>
					</div>

					<div class="btn-box">
						<div class="btn mgt10" :class="{ active: order.data.is_carpet!='3'}" @click="submitNext()">下一步</div>
					</div>
				</div>
      </v-modal>
    </transition>

    <div class="btn-box-fix">
      <div class="btn-container">

        <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">下一步</div>
      </div>
    </div>
    <img :src="pixelURL('clean','fangjian')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'clean-step2',
  data () {
    return {
      order:{},
      showModal:false
    }
  },
  methods: {
    allFilled(){
        if(this.order.data.livingroom && this.order.data.bedroom && this.order.data.bathroom && this.order.data.toiletroom){
            if(this.order.data.bedroom + this.order.data.livingroom > 0 || this.order.data.bedroom=='more' || this.order.data.livingroom=='more'){
              return true;
            }
        }
    },
    checkSubmit(){
      if(this.allFilled()){
        this.showModal = true;
      }
      else{
          if(parseInt(this.order.data.bedroom) + parseInt(this.order.data.livingroom) == 0){
            alert("客厅和卧室至少需要清洁一间以上")
          }
          else{
            alert('请填写完所有房间数目')
          }
      }
    },
    needCarpet(){
      this.orderUpdate('is_carpet','1');
      if(this.order.data.is_carpet==1 && this.order.data.carpet==0){
        this.order.data.carpet=1;
      }
    },
    submitNext(){
      if(this.allFilled()){
          if(this.order.data.is_carpet==3){
            alert('请选择是否需要清洁地毯')
          }
          else if(this.order.data.is_carpet==0){
            this.order.data.carpet = 0;
            this.orderUpdateAll('/clean-step3');
          }
          else{
            this.orderUpdateAll('/clean-step3');
          }
      }
      else{
          alert('请填写完所有房间数目')
      }
    },

    plus: function (type) {
      eval('this.order.data.'+type+'=this.order.data.'+type+'+1');
			if(this.order.data[type]>5){
				this.order.data[type]=5;
			}
		},
    minus: function (type) {
			eval('this.order.data.'+type+'=this.order.data.'+type+'-1');
			if(this.order.data[type]<1){
				this.order.data[type]=1;
			}
    },
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "clean"){
        this.order = localParsed;
        if(this.order.data.house_type==5&&!this.order.data.livingroom){
          this.order.data.livingroom = '0';
          this.order.data.bedroom = '1';
          this.order.data.bathroom = '1';
          this.order.data.toiletroom = '0';
        }
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.main{
	margin-top:14px;
}

.multilayer{
	text-align:center;
  margin:20px 0;
  .option-btn{
    border:2px solid #fe9567;
    border-radius:4px;
    min-width:68px;
    padding:0 8px;
    height:34px;
    line-height:34px;
    color:#ff7444;
    display:inline-block;
    margin:0 4px;
    text-align:center;
    background:#fff;
  }

  .option-btn.active{
    border:2px solid #fe9567;
    border-radius:4px;
    width:68px;
    height:34px;
    line-height:34px;
    background-color:#fe9567;
    color:#fff;
    display:inline-block;
    margin:0 4px;
    -webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    -moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  }
}

.item-title{
	margin:0 10vw 4px 10vw;
	display: flex;
	justify-content:left;
	align-items:center;
	font-size:1em;
	color:#5A5C68;
	img{
		margin-right:8px;
		width:32px;
	}
}
.item{
	margin:0 9vw 28px 9vw;
  display: flex;
	justify-content:left;
  align-items:center;
}


.option-btn{
	background:#eee;
  border-radius:4px;
  min-width:10vw;
	padding:2px 4px;
  height:28px;
  line-height:28px;
  color:#999;
  display:inline-block;
  margin:0 2vw;
	text-align:center;
	&.more{
		font-size:0.8em;
	}
}

.option-btn.active{
  background-color:#fe9567;
  color:#fff;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}


.info-box{
	min-height:60px;
	padding-top:13px;
}

.info{
	font-weight:100;
	text-align:center;
	padding-top:4px;
}

.carpetInfo{
	font-weight:100;
	text-align:center;
	padding-top:4px;
  font-size:0.8em;
  margin-bottom:20px;
}

.mgt10{
  margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/clean/step2.vue